// extracted by mini-css-extract-plugin
export default {"trigger":"category-tree-select_trigger__lzndF","treeContainer":"category-tree-select_treeContainer__XaWMe","node":"category-tree-select_node__98Axh"};